import { Link } from "react-router-dom";

import { PencilIcon } from "@heroicons/react/24/outline";
import { IconButton } from "../../../../../components/ui";
import { buildJobDetailsHref, getJobIdFromValues } from "../jobListNavigation";

const Actions = props => {
  const { values } = props || {};
  const id = getJobIdFromValues(values);

  if (id) {
    const href = buildJobDetailsHref({
      jobId: id,
      search: window.location.search,
    });

    return (
      <div className="user-list-actions flex text-right text-sm font-medium">
        {id && (
          <div className="grid">
            <Link to={href} title="Edit Jobs">
              <IconButton variant="clean" title="Edit Jobs">
                <PencilIcon
                  className={`h-4 w-4 cursor-pointer text-gray-400`}
                />
              </IconButton>
            </Link>
          </div>
        )}
      </div>
    );
  } else {
    return false;
  }
};

export default Actions;
